import axios from "axios";

//------------------------------------------------------------------
//------------------------------------------------------------------
import dlog from '../utils/log'
const ctx = "store_apicalls.js";
const ddlog = (msg) => { dlog(ctx,msg); }

//------------------------------------------------------------------
//------------------------------------------------------------------
const md5 = require("md5");
const salt = "pipirai";
//const hashVal = (val) => { return md5(val + salt); }
const hashVal = (val) => { return val; }

//------------------------------------------------------------------
//------------------------------------------------------------------
// const getApiAuthParams = () => {
//     return { uid: 1599, t: "1234567890" };
// }

//------------------------------------------------------------------
//------------------------------------------------------------------
const apiLogErr = async (errtxt) => {
    const url = '/api/';
    const data = { username:"myuser", password:hashVal("mypass"), meth:"errlog", txt:errtxt, t: new Date().getTime() };
    ddlog("~~~ apiLogErr: "+url);
    ddlog(data);
    const response = await axios.post(url, data);
    ddlog(response.data.data);
    return response.data.data;
}

export const wsLogErr = async (errtxt) => {
    try {
        await apiLogErr(errtxt);
    } catch(e) {}
}

//------------------------------------------------------------------
//------------------------------------------------------------------
export const apiLoginUser = async (uemail, upass) => {
    const url = '/api/';
    const data = { username:uemail, password:hashVal(upass), meth:"login", t: new Date().getTime() };
    ddlog("~~~ apiLoginuser: "+url);
    ddlog(data);
    const response = await axios.post(url, data);
    ddlog(response.data.data);
    return response.data.data;
}

//------------------------------------------------------------------
//------------------------------------------------------------------
export const apiFetchProjectListData = async (userid) => {
    const url = '/api/';
    const data = { uid:userid, meth:"uprj" };
    ddlog("~~~ apiFetchProjectListData: "+url);
    ddlog(data);
    const response = await axios.post(url, data);
    //ddlog(response.data);
    return response.data.data;
}

//------------------------------------------------------------------
//------------------------------------------------------------------
export const apiFetchProjectTaskListData = async (userid,prjid) => {
    const url = '/api/';
    const data = { uid:userid, prjid:prjid, meth:"uprjtsks" };
    ddlog("~~~ apiFetchProjectTaskListData: "+url);
    ddlog(data);
    const response = await axios.post(url, data);
    //ddlog(response.data);
    return response.data.data;
}

//------------------------------------------------------------------
//------------------------------------------------------------------
export const apiFetchProjectTaskProgressData = async (userid,prjid,tskid,tskdt) => {
    const url = '/api/';
    const data = { uid:userid, prjid:prjid, tskid: tskid, tskdt: tskdt, meth:"uprjtskprogress" };
    ddlog("~~~ apiFetchProjectTaskProgressData: "+url);
    ddlog(data);
    const response = await axios.post(url, data);
    //ddlog(response.data);
    return response.data.data;
}

//------------------------------------------------------------------
//------------------------------------------------------------------
export const apiSaveProjectTaskProgressData = async (userid,prjid,tskid,tskdt,work_amnt,material_amnt,material_in_amnt) => {
    const url = '/api/';
    const data = { uid:userid, prjid:prjid, tskid: tskid, tskdt: tskdt
                    , work_amnt: work_amnt, material_amnt: material_amnt, material_in_amnt: material_in_amnt
                    , meth:"savetskprogress" };
    ddlog("~~~ apiSaveProjectTaskProgressData: "+url);
    ddlog(data);
    const response = await axios.post(url, data);
    //ddlog(response.data);
    return response.data.data;
}

//------------------------------------------------------------------
//------------------------------------------------------------------
export const apiLoadEwtData = async (userid,prjid,tskid,tskdt) => {
    const url = '/api/';
    const data = { uid:userid, prjid:prjid, tskid: tskid, tskdt: tskdt
                    , meth:"loadewtdata" };
    ddlog("~~~ apiLoadEwtData: "+url);
    ddlog(data);
    const response = await axios.post(url, data);
    //ddlog(response.data.data);
    return response.data.data;
}

//------------------------------------------------------------------
//------------------------------------------------------------------
export const apiSaveEmployeeWorkedTime = async (userid,prjid,tskid,tskdt,ewtArr) => {
    const url = '/api/';
    const data = { uid:userid, prjid:prjid, tskid: tskid, tskdt: tskdt
                    , ewt: ewtArr
                    , meth:"saveewtdata" };
    ddlog("~~~ apiSaveEmployeeWorkedTime: "+url);
    ddlog(data);
    const response = await axios.post(url, data);
    //ddlog(response.data);
    return response.data.data;
}

//------------------------------------------------------------------
//------------------------------------------------------------------
export const apiSaveProjectFoto = async (userid,prjid,fcat,fdt,fcomment,fnonwtime,fb64) => {
    const url = '/api/';
    const data = { uid:userid, prjid:prjid, fdate: fdt
                    , fcat: fcat, fcomment: fcomment, fnonworktime: fnonwtime
                    , fotob64: fb64
                    , meth:"savefoto" };
    ddlog("~~~ apiSaveProjectFoto: "+url);
    //ddlog(data);
    let config = {
        onUploadProgress: function(progressEvent) {
                let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                ddlog("Upload progress: "+percentCompleted+"%");
        }
    };
    const response = await axios.post(url, data, config);
    //ddlog(response.data);
    return response.data.data;
}

//------------------------------------------------------------------
//------------------------------------------------------------------
export const apiLoadWeather = async (userid,prjid) => {
    const url = '/api/';
    const data = { uid:userid, project_id:prjid
                    , meth:"loadweather" };
    ddlog("~~~ apiLoadWeather: "+url);
    ddlog(data);
    const response = await axios.post(url, data);
    //ddlog(response.data.data);
    return response.data.data;
}

//------------------------------------------------------------------
//------------------------------------------------------------------
export const apiSaveWeather = async (userid,prjid,wid,wdt,wtm,stemp,atemp,hmdt,adew,wcom) => {
    const url = '/api/';
    const data = { uid:userid
                    , project_id:prjid
                    , weather_id:wid
                    , weather_date:wdt
                    , weather_time:wtm
                    , surface_temp:stemp
                    , air_temp:atemp
                    , humidity:hmdt
                    , above_dew:adew
                    , weather_comment:wcom
                    , meth:"saveweather" };
    ddlog("~~~ apiSaveWeather: "+url);
    ddlog(data);
    const response = await axios.post(url, data);
    //ddlog(response.data.data);
    return response.data.data;
}
